import { useCallback, useMemo, ComponentType } from "react"
import ListItemDropDownUnstyled from "components/list-item-dropdown"
import type { ListItemDropDownOption } from "components/list-item-dropdown/types"
import GraphTemplateSelector from "connected-components/graph/components/template-selector"
import PeriodDisplay from "connected-components/dashboard/components/period-display"
import { ModelMetadata } from "resources/models"
import { buildModelCategoryOptions } from "connected-components/graph/helpers"
import { useCategorySync } from "connected-components/graph/hooks/use-category-sync"
import { useGraphTemplateChart } from "../../hooks/use-graph-template-chart"
import { GRAPH_EXPOSURE_TEMPLATE_KEY, GRAPH_CATEGORY_DEFAULTS } from "../template-chart-config"

interface ListItemDropDownProps {
  label: string
  value: string
  setValue: (id: string) => void
  options: ListItemDropDownOption[]
  alignMenu?: "left" | "right"
  disablePortal?: boolean
}

const ListItemDropDown = ListItemDropDownUnstyled as ComponentType<ListItemDropDownProps>

const BASIC_CATEGORY_OPTIONS: ListItemDropDownOption[] = [{ id: "total", primaryText: "All Factors" }]

interface ExposureHeaderProps {
  modelMetadata: ModelMetadata
}

export default function ExposureHeader({ modelMetadata }: ExposureHeaderProps) {
  const { selectedCategory, setSelectedCategory, isPreferencesLoaded } = useGraphTemplateChart(
    GRAPH_EXPOSURE_TEMPLATE_KEY,
    GRAPH_CATEGORY_DEFAULTS,
  )

  const categoryOptions = useMemo<ListItemDropDownOption[]>(
    () => buildModelCategoryOptions(modelMetadata, BASIC_CATEGORY_OPTIONS),
    [modelMetadata],
  )

  useCategorySync(categoryOptions, selectedCategory, setSelectedCategory, isPreferencesLoaded)

  const handleCategoryChange = useCallback((category: string) => {
    setSelectedCategory(category)
  }, [setSelectedCategory])

  return (
    <>
      <GraphTemplateSelector />
      <PeriodDisplay isPerformance={false} />
      <ListItemDropDown
        label="Category"
        value={selectedCategory}
        setValue={handleCategoryChange}
        options={categoryOptions}
        alignMenu="left"
        disablePortal
      />
    </>
  )
}
